<div class="dialog-container">
  <div class="dialog-body">
    <img
      [src]="images.DELETE_ICON_LARGE"
      [alt]="'DELETE_ORDER.DELETE_ICON' | translate"
    />
    <div class="title">{{ 'DELETE_ORDER.DELETE_ORDER' | translate }}</div>
    <div class="description">
      {{ 'DELETE_ORDER.DELETE_ORDER_DESC' | translate }}
    </div>

    <div class="reason-container m-t-16">
      <nz-radio-group
        [(ngModel)]="selectedReason"
        (ngModelChange)="onReasonSelect($event)"
        name="reasonRadio"
        class="reason-container--radio-group wd-100"
      >
        <ng-container *ngFor="let reason of reasonOptions">
          <label
            nz-radio
            [nzValue]="reason.value"
            [ngClass]="{
              'selected-reason fw-600': selectedReason === reason.value
            }"
            class="reason-container--reason-item clr-999 fw-400"
          >
            <ng-container *ngIf="reason.value !== 'other'">
              {{ 'DELETE_ORDER.' + reason.reason | translate }}
            </ng-container>

            <!-- Show input if "Other" is selected -->
            <ng-container *ngIf="reason.value === 'other'">
              <input
                #otherReasonInput
                nz-input
                name="otherReason"
                placeholder="{{ 'DELETE_ORDER.OTHER_REASON' | translate }}"
                [(ngModel)]="otherReasonText"
                (ngModelChange)="onOtherReasonChange($event)"
                (click)="focusOtherInput()"
                class="reason-container--other-input"
                [nzBorderless]="true"
              />
            </ng-container>
          </label>
        </ng-container>
      </nz-radio-group>
    </div>
  </div>
  <div class="dialog-footer flex_sb">
    <button class="btn cancel-btn" (click)="cancelClicked()">
      {{ 'DELETE_ORDER.CANCEL' | translate }}
    </button>
    <button
      nz-button
      nzType="primary"
      [disabled]="!finalReason"
      class="btn delete-btn h-100"
      (click)="deleteClicked()"
    >
      {{ 'DELETE_ORDER.CONFIRM' | translate }}
    </button>
  </div>
</div>
